import React from "react";
import { Map, Marker, ZoomControl } from "pigeon-maps";
import { osm } from "pigeon-maps/providers";

const ShowMap = (props) => {
  const color = "#34495E";
  return (
    <div className="showMap">
      <Map
        provider={osm}
        height={props.height}
        zoomSnap={true}
        center={props.defaultCenter}
        zoom={props.zoom}
        // dprs={[1, 2]}
        // defaultCenter={props.defaultCenter}
        // anchor={[JSON.parse(props.defaultCenter.lat), JSON.parse(props.defaultCenter.lng)]}
        // defaultZoom={props.zoom}
        // onClick={(e) => props.setMarkerHandler(e)}
        // onBoundsChanged={props.defaultCenter, props.zoom}
      >
        <Marker
          width={30}
          anchor={props.anchor}
          color={color}
          // onClick={(e) => console.log(e)}
        />
        {/* <ZoomControl /> */}
      </Map>
    </div>
  );
};

export default React.memo(ShowMap);
